import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

import { computed } from "vue";
import { ArtifactNodeDisplayProps } from "@/types";
import {
  subtreeStore,
  permissionStore,
  traceSaveStore,
  viewsStore,
} from "@/hooks";
import { NodeDisplay } from "@/components/graph/display";
import { FlexBox, Separator, IconButton } from "@/components/common";


/**
 * Renders actions for the selected artifact node.
 */
const __default__ = {
  name: "ArtifactNodeActions",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    color: {},
    selected: { type: Boolean },
    hiddenChildren: {},
    artifact: {}
  },
  setup(__props: any) {

const props = __props;

const displayActions = computed(() =>
  permissionStore.isAllowed("project.edit_data")
);

const id = computed(() => props.artifact.id);

const hasSubtree = computed(
  () => subtreeStore.getChildren(id.value).length > 0
);
const showHiddenChildren = computed(() => props.hiddenChildren.length > 0);

return (_ctx: any,_cache: any) => {
  return (props.selected)
    ? (_openBlock(), _createBlock(_unref(NodeDisplay), {
        key: 0,
        color: props.color,
        variant: "sidebar",
        selected: props.selected,
        onMousedown: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"])),
        onMouseup: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(FlexBox), { column: "" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IconButton), {
                tooltip: "View related artifacts",
                icon: "view-tree",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(viewsStore).addDocumentOfNeighborhood(props.artifact)))
              }),
              (showHiddenChildren.value && hasSubtree.value)
                ? (_openBlock(), _createBlock(_unref(IconButton), {
                    key: 0,
                    tooltip: "Show subtree",
                    icon: "group-open-all",
                    "data-cy": "button-toggle-subtree",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(viewsStore).extendDocumentSubtree(props.artifact)))
                  }))
                : (hasSubtree.value)
                  ? (_openBlock(), _createBlock(_unref(IconButton), {
                      key: 1,
                      tooltip: "Hide subtree",
                      icon: "group-close-all",
                      "data-cy": "button-toggle-subtree",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(subtreeStore).hideSubtree(id.value)))
                    }))
                  : _createCommentVNode("", true),
              (displayActions.value)
                ? (_openBlock(), _createBlock(_unref(Separator), {
                    key: 2,
                    class: "full-width q-my-xs"
                  }))
                : _createCommentVNode("", true),
              (displayActions.value)
                ? (_openBlock(), _createBlock(_unref(IconButton), {
                    key: 3,
                    tooltip: "Add parent",
                    icon: "trace",
                    rotate: -90,
                    color: props.color,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (
          _unref(traceSaveStore).openPanel({
            type: 'source',
            artifactId: id.value,
          })
        ))
                  }, null, 8, ["color"]))
                : _createCommentVNode("", true),
              (displayActions.value)
                ? (_openBlock(), _createBlock(_unref(IconButton), {
                    key: 4,
                    tooltip: "Add child",
                    icon: "trace",
                    rotate: 90,
                    color: props.color,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (
          _unref(traceSaveStore).openPanel({
            type: 'target',
            artifactId: id.value,
          })
        ))
                  }, null, 8, ["color"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["color", "selected"]))
    : _createCommentVNode("", true)
}
}

})